import React from 'react';

import { styled } from '../theme';
import FieldHintText from './FieldHintText';
import FieldLabel from './FieldLabel';
import FieldStatusText from './FieldStatusText';
import FlexRow from './FlexRow';
import FormGroup from './FormGroup';
import Input from './Input';

const StyledFieldHintText = styled(FieldHintText)({
    textAlign: 'left',
    display: 'block',
    width: '100%',
});

const StyledInput = styled(Input)({
    fontSize: '1.6rem',
});

type Props = Omit<React.ComponentProps<typeof Input>, 'error'> & {
    name: string;
    value: string;
    onChange?: (ev: { target: { name: string; value: string } }) => void;
    label?: string;
    placeholder?: string;
    autoFocus?: boolean;
    required?: boolean;
    error?: React.ReactNode;
    counter?: number;
    hint?: string;
    hintClassName?: string;
};

const FormInput = React.forwardRef<HTMLInputElement, Props>(
    ({ onChange, error, ...props }, ref) => {
        const valueLength = props.counter != null && (props.value == null ? 0 : props.value.length);

        const handleChange = (ev) => {
            if (props.counter != null) {
                const len = ev.target.value.length;
                if (len > props.counter) {
                    return;
                }
            }

            onChange(ev);
        };

        return (
            <FormGroup itemsSpacing={5}>
                <FlexRow justify="space-between">
                    <FieldLabel>{props.label}</FieldLabel>
                    <FieldLabel>
                        {props.counter != null && `${valueLength}/${props.counter}`}
                    </FieldLabel>
                </FlexRow>
                <StyledInput ref={ref} onChange={handleChange} error={!!error} {...props} />
                {props.hint && (
                    <StyledFieldHintText className={props.hintClassName}>
                        {props.hint}
                    </StyledFieldHintText>
                )}
                <FieldStatusText status="error">{error}</FieldStatusText>
            </FormGroup>
        );
    }
);

export default FormInput;
